import { useAppNotifications } from "@/hooks/useAppNotifications";
import { gql } from "@/gql";
import { useQuery } from "@apollo/client/react";

import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "@/utils/showErrorToast";

const ACCOUNT = gql(`
  query Account($id: ID!) {
    account(id: $id) {
      ...AccountDetails
    }
  }
`);

export const useAccountDetails = (
  accountId?: string,
  options?: { skip?: boolean }
) => {
  const notifications = useAppNotifications();
  const { t } = useTranslation();
  const hasShownErrorRef = useRef(false);

  const { data, loading, error } = useQuery(ACCOUNT, {
    variables: { id: accountId ?? "" },
    skip: !accountId || options?.skip,
    context: { skipGlobalError: true },
  });

  useEffect(() => {
    if (!error) {
      hasShownErrorRef.current = false;
      return;
    }

    if (hasShownErrorRef.current) return;
    hasShownErrorRef.current = true;

    showErrorToast(notifications, error, t("accounts.error_loading_accounts"));
  }, [error, notifications, t]);

  return {
    account: data?.account,
    loading,
    error,
  };
};
